
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 26 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.314 7.333H1.486A.676.676 0 01.8 6.667c0-.369.307-.667.686-.667h17.828c.379 0 .686.298.686.667a.676.676 0 01-.686.666zM4.086 12.667h17.828A.676.676 0 0022.6 12a.676.676 0 00-.686-.667H4.086A.676.676 0 003.4 12c0 .368.307.667.686.667zM6.686 18h17.828a.676.676 0 00.686-.667.676.676 0 00-.686-.666H6.686a.676.676 0 00-.686.666c0 .369.307.667.686.667z","fill":"#fff"}})])
          )
        }
      }
    